'use client'
import { SeparatorProps } from './Interface'

export const Separator = ({ text }: SeparatorProps) => {
  return <div className="font-semibold text-sm  my-4">{text}</div>
}
